export const ROOT_PACKAGE_ID = "__package__" as const;
